import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import BlockTitle from '@/features/editorial/components/home/modules/blocks/BlockTitle.vue';
import GuideStreamingChartsItem from '@/features/editorial/components/home/modules/blocks/streaming-charts/GuideStreamingChartsItem.vue';

import { type StreamingChartsTitle } from '@/features/editorial/types/editorial-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingCharts',
  props: {
    blockData: null,
    blockIndex: null,
    moduleIndex: null
  },
  setup(__props: any) {

const props = __props as {
	blockData: { titles: StreamingChartsTitle[]; translatables: { title: string } };
	blockIndex: number;
	moduleIndex: number;
};



const titles = computed(() => props.blockData.titles);

return { __sfc: true,props, titles, BlockTitle, GuideStreamingChartsItem }
}

})